const $rmcp = localStorage.getItem('__rmcp');
if ($rmcp !== null || $rmcp != 'null') window.__rmcp = $rmcp;
